import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, Grid2, Tooltip } from "@mui/material";
// styles
import styles from "./IconButton.module.scss";

export default function IconButton(props) {
  const { icon, tooltipText, onClick, isActive, className, loading } = props;
  const Icon = icon;

  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <Grid2
        className={`${styles.IconButtonBox} ${
          isActive ? styles.active : ""
        } ${className}`}
        onClick={onClick}
      >
        <Grid2 className={styles.iconBox}>
          {loading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <Icon className={styles.icon} />
          )}
        </Grid2>
      </Grid2>
    </Tooltip>
  );
}

IconButton.propTypes = {
  icon: PropTypes.elementType.isRequired, // SvgIconComponent
  tooltipText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  className: PropTypes.string,
  loading: PropTypes.bool,
};
